import React from "react";

export function MarketplaceAlmostThereBanner({ title, body }) {
  return (
    <div className="marketplace-almost-there-banner mb-4">
      {title && (
        <h4 className="marketplace-almost-there-title fw-bold mb-2">{title}</h4>
      )}
      <p className="marketplace-almost-there-body mb-0">{body}</p>
    </div>
  );
}

export function MarketplaceConnectEmpty({ connectPrompt, icon, onConnect, canEdit }) {
  return (
    <div className="marketplace-empty-state d-flex flex-column align-items-center justify-content-center text-center px-4 py-5">
      <div className="marketplace-empty-icon-wrap d-flex align-items-center justify-content-center mb-4 position-relative">
        <div className="marketplace-empty-icon-ring" />
        {icon}
      </div>
      <h3 className="fw-bold mb-2 marketplace-empty-title">{connectPrompt.title}</h3>
      <p className="mb-4 marketplace-empty-desc">{connectPrompt.body}</p>
      <button
        type="button"
        onClick={onConnect}
        disabled={!canEdit}
        className="btn btn-danger border-0 position-relative overflow-hidden marketplace-connect-btn"
      >
        {connectPrompt.buttonLabel}
      </button>
    </div>
  );
}

export function MarketplaceProgressStrip({ hasSp, hasAds, connectedCount = 0 }) {
  const progressSubtitle =
    connectedCount === 0
      ? "0 of 2 connected — connect Seller Central first."
      : "1 of 2 connected — one more step to complete your setup.";

  return (
    <div className="card marketplace-progress-strip mb-5 mb-xl-8">
      <div className="card-body d-flex align-items-center justify-content-between flex-wrap gap-4 py-4 px-5">
        <div>
          <div className="fw-bold fs-5 marketplace-progress-strip-title">Connect both accounts for full P&amp;L</div>
          <div className="text-muted fs-7 mt-1">{progressSubtitle}</div>
        </div>
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <span className={`marketplace-progress-step ${hasSp ? "is-done" : "is-pending"}`}>
            <i className={`bi ${hasSp ? "bi-check-circle-fill" : "bi-circle"} me-2`} />
            Seller Central
          </span>
          <span className="marketplace-progress-divider" />
          <span className={`marketplace-progress-step ${hasAds ? "is-done" : "is-pending"}`}>
            <i className={`bi ${hasAds ? "bi-check-circle-fill" : "bi-circle"} me-2`} />
            Advertising
          </span>
        </div>
      </div>
    </div>
  );
}
